import { Tooltip, Icon, Avatar } from "antd";
import React, { Component, useContext, useState, useEffect } from "react";
import UserAvatar from "react-user-avatar";
//import './tc_user_avatar.css'
import { AppContext } from "../../AppContext";
import { hot } from "react-hot-loader";
import { User } from "../../services/generated-sdk/models/User";
import { getAvatarURL } from "../../utils/common-ts";
import * as _ from "lodash";
import {
  formatNmae,
  getAvatarDisplayFormat,
  formatAvatarDisplayName,
  AVATAR_DISPLAY_FORMATS,
} from "../../utils/common";

function TCUserAvatar(props: TCAvatarProps) {
  const { userIndex, deletedUserIndex, company } = useContext(AppContext);
  const allUsers = Object.assign({}, userIndex, deletedUserIndex);
  const id = typeof props.id != "string" ? props.id : parseInt(props.id);
  // TCV-6564: showFormatLabel reads the company setting; withName always shows full name
  const avatarFormat = props.showFormatLabel
    ? getAvatarDisplayFormat(props.company || company)
    : AVATAR_DISPLAY_FORMATS.INITIALS;

  useEffect(() => {}, [props.name]);
  if (!props.id) {
    return (
      <a style={{ color: "#fff" }} title="Unassigned">
        <span className="avatar-span">
          <Avatar size={28} icon="user" />
          &nbsp;
          {props.withName ? (
            <span style={{ color: "#000" }}>Unassigned</span>
          ) : null}
        </span>
      </a>
    );
  }

  if (id && !allUsers[id] && !deletedUserIndex[id]) {
    return props.name ? (
      <span>
        <UserAvatar {...props} name={formatNmae(props.name)} size={28} />{" "}
        {props.withName
          ? avatarFormat !== AVATAR_DISPLAY_FORMATS.INITIALS
            ? formatAvatarDisplayName(props.name, avatarFormat)
            : props.name
          : avatarFormat !== AVATAR_DISPLAY_FORMATS.INITIALS
          ? formatAvatarDisplayName(props.name, avatarFormat)
          : null}
      </span>
    ) : (
      <Avatar icon="user" {...props} />
    );
  }
  let selectedUser: User = allUsers[id];

  props = {
    size: 28,
    ...props,
  };

  let newProps: any = { ...props };
  if (selectedUser) {
    const name = formatNmae(
      props.name ? props.name : selectedUser ? selectedUser.name : "Unassigned"
    );
    newProps.name = name;

    // if avatar found
    if (selectedUser.avatar) {
      newProps.src = getAvatarURL(selectedUser.avatar);
    }
  }
  const isDeletedUser =
    deletedUserIndex && deletedUserIndex[id] != undefined ? true : false;

  return (
    <a
      style={{ color: "#fff" }}
      target="_blank"
      href={isDeletedUser ? "/" : `/profile/${selectedUser.username}`}
      title={selectedUser.name}
    >
      <span className="avatar-span">
        <UserAvatar {...newProps} />
        &nbsp;
        {props.withName ? (
          <span style={{ color: "rgba(0, 0, 0, 0.75)" }}>
            {avatarFormat !== AVATAR_DISPLAY_FORMATS.INITIALS
              ? formatAvatarDisplayName(selectedUser.name, avatarFormat)
              : newProps.name}
          </span>
        ) : avatarFormat !== AVATAR_DISPLAY_FORMATS.INITIALS ? (
          <span style={{ color: "rgba(0, 0, 0, 0.75)" }}>
            {" "}
            {formatAvatarDisplayName(selectedUser.name, avatarFormat)}
          </span>
        ) : null}
      </span>
    </a>
  );
}
export default hot(module)(TCUserAvatar);

export interface TCAvatarProps {
  id: number | string;
  name?: string;
  src?: string;
  size?: number;
  className?: string;
  textColor?: string;
  withName?: boolean;
  // TCV-6564: opt-in formatted name for assignee displays
  showFormatLabel?: boolean;
  company?: any;
}
